export type ContactPersonInvitationResult = "ok" | "already-cp" | "not-invited";
